var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return __webpack_require__.e(938).then(next);
};